import { useCallback } from 'react';
import {
  updateMetroSearchSelectedMetroContext,
  useUiValue,
} from 'stores/uiContext';

const useMetroSearchSelectedMetro = () => {
  const [{ metroSearchSelectedMetro }, dispatch] = useUiValue();

  const updateMetroSearchSelectedMetro = useCallback(
    (metro) => {
      dispatch(updateMetroSearchSelectedMetroContext(metro));
    },
    [dispatch],
  );

  return {
    metroSearchSelectedMetro,
    updateMetroSearchSelectedMetro,
  };
};

export default useMetroSearchSelectedMetro;
